

import React, { useEffect, useState } from 'react';
import './dstyle.css';
import SideBar from './SideBar';
import Navbar from './Navbar';
import { API_BASE_URL } from '../../config/api';

function Tutors() {
  const [tutors, setTutors] = useState([]);
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/courses`)
      .then((data) => data.json())
      .then((res) => {
        if (Array.isArray(res)) {
          const list = res.map((c, i) => ({
            id: c.course_id || i + 1,
            tutor_name: c.instructor || "Lead Instructor",
            tutor_email: `instructor.${c.course_id || i + 1}@consortium.com`,
            tutor_phno: "+1 (555) 019-2834",
            tutor_qualification: c.course_name || "Course Lead"
          }));
          setTutors(list);
        }
      })
      .catch((err) => console.error(err));
  }, []);
  return (
    <div style={{ backgroundColor: "#f8fafc", minHeight: "100vh" }}>
      <SideBar current={"tutor"}/>
      <section id="content">
        <Navbar />
        <main>
          <div className="table-data" style={{marginTop:"-10px"}}>
            <div className="order">
              <div className="head">
                <h3>Tutors Info</h3>
                {/* <i className='bx bx-search' id="i"></i>
                <i className='bx bx-filter' id="i"></i> */}
              </div>
              <table id="user">
                <thead>
                  <tr>
                    {/* <th>Sno</th>  */}
                    <th>Tutorname</th>
                    <th>Email</th>
                    <th>Phone Number</th>
                    <th>Qualification</th>
                  </tr>
                </thead>
                <tbody>
                {tutors.map((tutor) => (
                   <tr>
                    {/* <td>{user.id}</td> */}
                   <td><p>{tutor.tutor_name}</p></td>
                   <td>{tutor.tutor_email}</td>
                   <td>{tutor.tutor_phno}</td>
                   <td>{tutor.tutor_qualification}</td>
                 </tr>
                ))}
                </tbody>
              </table>
            </div>
          </div>
        </main>
      </section>
    </div>
  );
}

export default Tutors;
